import React, { useEffect } from 'react';
import './DownloadAppModal.css';

// Shared "Scan the QR code and download the app" popup. Rendered once at
// the top level (App.js) and controlled by a global click-interceptor
// there — any existing <a href="https://onelink.to/wch597"> across every
// page opens this instead of navigating away, so no per-page wiring is
// needed as new pages/links are added later (just keep using that same
// href and it's automatically caught).
export default function DownloadAppModal({
  open,
  onClose,
  qrSrc,
  qrLink,
  iosLink,
  androidLink,
}) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="download-app-modal-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="download-app-modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Get the Scallop app"
      >
        <button
          type="button"
          className="download-app-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <a
          href={qrLink}
          target="_blank"
          rel="noopener noreferrer"
          className="download-app-modal-qr-link"
        >
          <img
            src={qrSrc}
            alt="QR code to download the Scallop app"
            className="download-app-modal-qr-img"
          />
        </a>
        <h3 className="download-app-modal-title">
          Scan the QR code and download the app
        </h3>
        <p className="download-app-modal-subtitle">
          Point your phone camera at the code to open the download page.
        </p>
        {iosLink && androidLink && (
          <div className="download-app-modal-stores">
            <span className="download-app-modal-stores-divider">
              or pick your store
            </span>
            <a
              href={iosLink}
              target="_blank"
              rel="noopener noreferrer"
              className="download-app-modal-store-btn download-app-modal-store-btn-ios"
            >
              Download for iOS
            </a>
            <a
              href={androidLink}
              target="_blank"
              rel="noopener noreferrer"
              className="download-app-modal-store-btn download-app-modal-store-btn-android"
            >
              Download for Android
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
